import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchStagedFiles } from '@/services/git/api';
import type { StagedFile } from '@/services/git/types';
import { useAuthStoreV1 } from '@/stores/authStore_v1';

export function useStagedFiles(options?: { enabled?: boolean }): UseQueryResult<StagedFile[], Error> {
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id);

  return useQuery({
    queryKey: ['stagedFiles', orgId],
    queryFn: () => fetchStagedFiles(orgId!),
    enabled: (options?.enabled ?? true) && !!orgId,
    staleTime: 0,
    refetchOnWindowFocus: true,
  });
}
